<template>
  <ui-content title="Guía Reporte">
    <ui-card v-if="loading.view == false">
      <div class="row form-row align-items-center mb-2">
        <div class="col-lg-3">
          <label for="" class="form-label">Guía:</label>
          <select class="form-control form-control-sm" v-model="form.guia">
            <option v-for="item in containers.guias" :key="item.idPersona" :value="item.idPersona">{{ item.nombre }} </option>
          </select>
        </div>
        <div class="col-lg-3">
          <label for="" class="form-label">Fecha Inicio:</label>
          <date-picker v-model="form.fecha_inicio" format="DD-MM-YY" value-type="YYYY-MM-DD" input-class="form-control form-control-sm" :editable="false"></date-picker>
        </div>
        <div class="col-lg-3">
          <label for="" class="form-label">Fecha Fin:</label>
          <date-picker v-model="form.fecha_fin" format="DD-MM-YY" value-type="YYYY-MM-DD" input-class="form-control form-control-sm" :editable="false"></date-picker>
        </div>
        <div class="col-lg-3" v-if="usuarios.length">
          <label for="" class="form-label">Usuario:</label>
          <select class="form-control form-control-sm" v-model="form.usuario">
            <option value="">Todos</option>
            <option v-for="item in usuarios" :key="item" :value="item">{{ item }} </option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <button class="btn btn-primary" @click="onSearch" :disabled="loading.search">
          Buscar
        </button>
        <button v-if="reporteFiltrado.length" class="btn btn-outline-secondary ml-2" @click="onPrint">
          Imprimir
        </button>
      </div>
      <hr />
      <b-table-lite bordered small responsive :items="reporteFiltrado" :fields="containers.tableFields" head-variant="light">
        <template v-slot:cell(fecha)="{ item: { fecha } }">
          {{ fecha ? $dayjs(fecha).format("DD-MM-YY") : "" }}
        </template>
      </b-table-lite>
    </ui-card>
  </ui-content>
</template>
<script>
import { BTableLite } from "bootstrap-vue";
import DatePicker from "vue2-datepicker";
import pdfReporteGuias from "@/modules/reportes/pdf/pdfReporteGuias.js";

export default {
  components: {
    DatePicker,
    BTableLite,
  },
  data() {
    return {
      form: {
        guia: "",
        fecha_inicio: "",
        fecha_fin: "",
        usuario: "",
      },
      reportes: [],
      containers: {
        guias: [],
        tableFields: [
          {
            key: "codigo",
            label: "Cód.",
          },
          "tabla",
          "fecha",
          "pasajero",
          "agencia",
          "servicio",
          {
            key: "tipoServicio",
            label: "Tipo",
          },
          {
            key: "pax",
            label: "PAX",
          },
          {
            key: "chd",
            label: "CHD",
          },
          "idioma",
          {
            key: "usuarioCreador",
            label: "Usuario Creador",
          },
        ],
      },
      loading: {
        view: true,
        search: false,
      },
    };
  },
  created() {
    const vm = this;

    vm.axios.get("/guias").then((response) => {
      vm.containers.guias = response.data.content;
      vm.form.guia = response.data.content.length ? response.data.content[0].idPersona : "";
      vm.loading.view = false;
    });
  },
  computed: {
    usuarios() {
      const vm = this;
      let usuarios = vm.reportes.map((item) => item.usuarioCreador);
      usuarios = [...new Set(usuarios)];
      return usuarios;
    },
    reporteFiltrado() {
      const vm = this;
      if (vm.form.usuario == "") return vm.reportes;
      return vm.reportes.filter((item) => item.usuarioCreador == vm.form.usuario);
    },
    guia() {
      if (!this.form.guia) return "";
      return this.containers.guias.find((item) => item.idPersona == this.form.guia)?.nombre || "";
    },
  },
  methods: {
    onSearch() {
      const vm = this;

      if (!(vm.form.guia && vm.form.fecha_inicio && vm.form.fecha_fin)) {
        return vm.$toast.fire("Completa todos los campos", "", "warning");
      }

      if (vm.$dayjs(vm.form.fecha_inicio) > vm.$dayjs(vm.form.fecha_fin)) {
        return vm.$toast.fire("Fecha inicio no puede ser mayor a fecha fin", "", "warning");
      }

      vm.reportes = [];
      vm.loading.search = true;

      vm.axios
        .get(`/reportes/guias/${vm.form.guia}`, {
          params: vm.form,
        })
        .then((response) => {
          vm.reportes = response.data.content;
        })
        .finally(() => {
          vm.loading.search = false;
        });
    },
    onPrint() {
      const vm = this;

      const registros = this.reporteFiltrado.map((item) => ({
        ...item,
        fecha: vm.$options.filters.date(item.fecha),
      }));

      pdfReporteGuias({
        registros,
        header: {
          guia: this.guia,
          fecha_inicio: vm.$options.filters.date(vm.form.fecha_inicio),
          fecha_fin: vm.$options.filters.date(vm.form.fecha_fin),
          usuario: this.form.usuario,
        },
        userMark: vm.$store.state.user,
        dateMark: vm.$dayjs().format("DD-MM-YY HH:mm"),
      });
    },
  },
};
</script>
